// NPM MODULES
import { Box, Typography } from '@mui/material';
import { DateTime } from 'luxon';
import React from 'react';
import FormattedMessages from '../../../messages/admin/TraceLogFormattedMessages';
import { AdminRoutes } from '../../../routes/AdminRoutes';
import Layout from '../../layouts/Layout';

const SingleTraceLog = ({
  traceLog,
  backButtonClick,
  accessLevel,
  accessType,
}) => {
  if (!traceLog) return <Typography>No Data</Typography>;

  const logTime = DateTime.fromISO(traceLog.created_at).toUTC();
  const traceLogView = JSON.stringify(
    { ...traceLog, json_object: undefined },
    null,
    2
  );

  return (
    <Layout
      routes={AdminRoutes}
      title="Trace Log Details"
      accessLevel={accessLevel}
      accessType={accessType}
      backButtonText={FormattedMessages.back}
      handleBackButton={backButtonClick}
    >
      <Box>
        <Typography fontWeight={700}>
          {FormattedMessages.tableHeaderLogTime}
        </Typography>
        <Typography gutterBottom>
          {logTime.toFormat('dd-LLL-yyyy h:mm:ss a')}
        </Typography>

        <Typography fontWeight={700}>
          {FormattedMessages.tableHeaderLogLevel}
        </Typography>
        <Typography gutterBottom>{traceLog.log_level}</Typography>

        <Typography fontWeight={700}>
          {FormattedMessages.tableHeaderLogGroupId}
        </Typography>
        <Typography gutterBottom>{traceLog.log_group_id || 'N/A'}</Typography>

        <Typography fontWeight={700}>
          {FormattedMessages.tableHeaderProcessName}
        </Typography>
        <Typography gutterBottom>{traceLog.process_name}</Typography>

        <Typography fontWeight={700}>
          {FormattedMessages.tableHeaderProgramName}
        </Typography>
        <Typography gutterBottom>{traceLog.program_name}</Typography>

        <Typography fontWeight={700}>
          {FormattedMessages.tableHeaderLogMessage}
        </Typography>
        <Typography gutterBottom>{traceLog.log_message}</Typography>

        <Typography fontWeight={700}>
          {FormattedMessages.tableHeaderTag}
        </Typography>
        <Typography gutterBottom>{traceLog.tag || 'N/A'}</Typography>

        <Typography fontWeight={700}>
          {FormattedMessages.tableHeaderJson}
        </Typography>
        <Box
          component="pre"
          sx={{
            backgroundColor: 'grey.100',
            p: 2,
            borderRadius: 1,
            overflowX: 'auto',
            fontFamily: 'monospace',
            fontSize: '0.875rem',
            mb: 2,
          }}
        >
          {JSON.stringify(JSON.parse(traceLog.json_object), null, 2)}
        </Box>

        <Typography fontWeight={700}>
          {FormattedMessages.tableHeaderAllFields}
        </Typography>
        <Box
          component="pre"
          sx={{
            backgroundColor: 'grey.100',
            p: 2,
            borderRadius: 1,
            overflowX: 'auto',
            fontFamily: 'monospace',
            fontSize: '0.875rem',
            mb: 2,
          }}
        >
          {traceLogView}
        </Box>
      </Box>
    </Layout>
  );
};

export default SingleTraceLog;
